<template>
  <div>
    <div class="right-title">
      <span>简历详情</span>
      <el-button plain class="go-back" @click="goBack" v-if="historyNum>2">返回</el-button>
    </div>
    <div class="content-box" v-if="isLoading">
      <div style="width: 900px;margin: 0 auto;">
        <div class="box1">
          <div class="left">
            <img :src="headimg" alt="">
          </div>
          <div class="right">
            <h1>{{user.user_real_name}}</h1>
            <p>
              {{user.sex | sex}} <span>|</span>{{user.birthday | birthday}}<span>|</span>{{user.address_name | address}}
            </p>
            <div>
              <span><i class="iconfont icondianhua"></i>{{user.phone}}</span>
              <span><i class="iconfont iconweibiaoti554"></i>{{user.email}}</span>
            </div>
          </div>
        </div>
        <div class="box2" >
          <h2 class="title">附件简历</h2>
          <div class="list">
            <div style="width: 100%;">
              <a :href="data.resume.file_path" style="color: #00a2ea;" target="_blank" :download="user.user_real_name+'的简历'">{{user.user_real_name}}的简历</a>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.type === 1">
          <h2 class="title">目前职业概况</h2>
          <div class="list">
            <div>
              <span>所属领域:</span>{{data.resume.industry}}
            </div>
            <div>
              <span>目前职位:</span>{{data.resume.position}}
            </div>
            <div>
              <span>目前机构:</span>{{data.resume.organization_name}}
            </div>
            <div>
              <span>期望年薪:</span>{{data.resume.annual_salary}}万元
            </div>
          </div>
        </div>
        <div class="box2">
          <h2 class="title">工作经历</h2>
          <div class="items" v-for="(item,index) in data.work_history" :key="index">
            <div class="left-icon">
              <i></i>
            </div>
            <div class="list">
              <div style="width: 100%;display: flex;align-items: center;justify-content: space-around">
                <span>机构名称：{{item.name}}</span>
                <span>所在部门:{{item.job}}</span>
                <span>{{item.start }} - {{item.end ?item.end :'至今'}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box2" >
          <h2 class="title">教育经历</h2>
          <div class="items items2" >
            <div class="left-icon">
              <i></i>
            </div>
            <div class="list">
              <div style="width: 100%;display: flex;align-items: center;justify-content: space-around">
                <span>{{data.education_history.school}}</span>
                <span>{{data.education_history.zhuanye}} </span>
                <span>{{data.education_history.education_cn}}</span>

                <span class="times">{{data.education_history.start_time }} - {{data.education_history.checked?'至今':data.education_history.end_time}}</span>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
    <footerBox class="footer"/>

  </div>
</template>

<script>
import footerBox from '../components/rightBottom'
import config from '../../../../config/index'

export default {
  name: "hxrResume",
  data() {
    return {
      headimg: '',      //  头像
      data: {},         //  简历数据
      user: {},          //  候选人信息

      isLoading: false,
      historyNum:0
    }
  },
  computed: {
    userinfo() {
      return this.$store.state.user
    }
  },
  created() {

    this.$emit('setType', 0)
    // 获取简历数据
    this.init()
    this.historyNum = history.length
  },
  methods: {
    async init() {
      const loading = this.$loading({
        target: this.$refs.container,
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      let res = await this.$api.apiContent.showPushResume({
        admin_id: this.userinfo.id,
        resumeId: this.$route.params.id,
        jobId: this.$route.query.jobId,
      })
      let data = res.data

      // data.resume.img_ids = !data.resume.img_ids ? [] : data.resume.img_ids.split(',')
      // data.resume.lable_ids = !data.resume.lable_ids ? [] : data.resume.lable_ids.split(',')
      //
      // data.resume.accessory_path = config.downUrlStr + '?urlFile='+ data.resume.accessory_path + '&userToken='+ this.$route.query.resumeId
      data.resume.file_path = config.urlStr +  data.resume.file_path
      //
      // data.resume.type = config.urlStr + '/' + data.resume.type
      this.data = data
      this.user = data.userinfo
      this.headimg = config.urlStr + '/' + data.userinfo.headimg

      loading.close();
      this.isLoading = true
    },






    goBack() {     //  返回上一页
      this.$tools.goBack()
    },
  },
  watch: {},
  filters: {
    //  听说读写
    lang(val) {
      let num = Number(val)
      if (num === 1) {
        return '精通'
      }
      if (num === 2) {
        return '良好'
      }
      if (num === 3) {
        return '一般'
      }
      if (num === 4) {
        return '不具备'
      }
    },
    //  时间转化
    time(val) {
      let num = Number(val)
      if (num === 0) {
        return '至今'
      } else {
        let date1 = new Date(num * 1000)
        let _dates = date1.getFullYear() + "." + ((date1.getMonth() + 1) < 10 ? "0" + (date1.getMonth() + 1) : (date1.getMonth() + 1)) + "." + (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate())
        return _dates
      }
    },
    type(val) {
      // 1全职 2实习 3兼职 4短期
      let num = Number(val)
      if (num === 1) {
        return '全职'
      }
      if (num === 2) {
        return '实习'
      }
      if (num === 3) {
        return '兼职'
      }
      if (num === 4) {
        return '短期'
      }
    },
    // 转化性别
    sex(val) {
      if (Number(val) === 1) {
        return '男'
      } else if (Number(val) === 2) {
        return '女'
      }
    },
    // 根据生日转化年龄
    birthday(val) {
      let nian = new Date().getYear()
      let nian1 = new Date(val * 1000).getYear()
      return (nian - nian1) + '岁'
    },
    // 转化地址
    address(val) {
      let arr = val.split('|')
      return arr[0]
    }
  },
  components: {
    footerBox
  }
}
</script>

<style scoped lang="scss">
.right-title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .conten-btn-box {
    .conter-btn {
      height: 30px;
      padding: 0 15px;
    }
  }
}

.content-box {

  .box1 {
    display: flex;
    align-items: center;
    padding: 25px 50px;
    background: #fff;
    margin-bottom: 10px;

    .left {
      width: 126px;
      height: 156px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .right {
      padding-left: 20px;

      h1 {
        line-height: 56px;
        font-size: 36px;
        font-weight: normal;
      }

      p {
        line-height: 40px;

        span {
          padding: 0 10px;
        }
      }

      div {
        line-height: 40px;

        span {
          padding-right: 10px;

          i {
            position: relative;
            top: 1px;
            font-size: 18px;
            color: #00a2ea;
            padding-right: 5px;
          }
        }

      }
    }
  }

  .box2 {
    padding: 30px 20px;
    background: #fff;
    margin-bottom: 10px;

    .title {
      line-height: 44px;
      font-size: 22px;
    }

    .list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 50%;
        line-height: 40px;

        span {
          display: block;
          //min-width: 100px;
          color: #333;
          margin-right: 30px;
        }

        b {
          padding: 0 30px 0 10px;
        }
      }
    }

    .items {
      padding: 40px 60px;
      position: relative;

      .time {
        color: #333;
        margin-bottom: 20px;
      }

      .list {
        padding-left: 40px;
      }

      .left-icon {
        position: absolute;
        top: 50px;
        left: 30px;
        width: 20px;
        height: 20px;
        background-color: #90d5f3;
        border-radius: 100%;

        i {
          position: absolute;
          top: 4px;
          left: 4px;
          width: 12px;
          height: 12px;
          background-color: #00a2ea;
          border-radius: 100%;
        }
      }

      .left-shu {
        position: absolute;
        top: 55px;
        left: 40px;
        width: 2px;
        height: 100%;
        background-color: #90d5f3;
      }
    }

    .items2 {
      //padding: 28px 60px;

      .list {
        div {
          display: flex;
          align-items: center;
          height: 40px;
          line-height: 40px;
          span {
            display: block;
            line-height: 40px;
            color: #333;
          }

          span.times {
            display: block;
            line-height: 40px;
            color: #333;
          }
        }
      }

    }
  }

  .box3 {
    position: absolute;
    top: 100px;
    right: -200px;
    width: 200px;
    padding: 20px;

    div {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: left;
      padding-left: 10px;
      margin-bottom: 10px;
      background: #fff;
      border: 1px solid #ddd;
      cursor: pointer;
    }
  }
}

.dialogBox {
  .title {
    font-size: 20px;
    text-align: center;
  }

  .list-lable {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .label-item {
      display: flex;
      align-items: center;
      margin: 0 20px 20px 0;

      span {
        display: block;
        padding: 5px 10px;
        color: #00a2ea;
        border: 1px solid #00a2ea;
      }

      b {
        padding: 0 5px;
        color: #00a2ea;
      }

      i {
        cursor: pointer;
      }
    }
  }

  .msbg-box {
    display: flex;
    align-items: center;
    padding: 20px 0;

    .ms-left {
      width: 50%;
      height: 400px;

      border-right: 1px solid #ddd;
      overflow-y: scroll;

      p {
        line-height: 38px;
        padding: 0 10px;
        border-bottom: 1px solid #ddd;

        &.active {
          background: #00a2ea;
          color: #fff;
        }
      }
    }

    .ms-left::-webkit-scrollbar {
      display: none;
    }

    .ms-right {
      width: 50%;
      height: 400px;
      padding: 0 10px;
      overflow-y: scroll;

      h3 {
        text-align: center;
        font-size: 16px;
        margin-bottom: 10px;
      }

      div {
        line-height: 24px;
      }
    }

    .ms-right::-webkit-scrollbar {
      display: none;
    }
  }
}

.add-label {
  display: flex;
  align-items: center;

  span {
    display: block;
    width: 120px;
  }

  .label-add-input {
    width: 250px;
    margin-right: 20px;
  }

  .add-label-btn {
    cursor: pointer;
  }
}
</style>